// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_77za_","upperButton":"_2LAgP","loader":"ZDUJJ","rotate":"YWPjv"};